module.exports = __webpack_public_path__ + "img/FES-Jakarta-RZ033.ed8e426a.jpg";